import gql from 'graphql-tag';

export default gql`
    query GetSetup($jobId: Int) {
        getSetup(jobId: $jobId) {
            rowCount
            columnCount
            rowDetails {
                id
                descrip
            }
            columnDetails {
                id
                descrip
            }
        }
    }
`;
